import React from 'react'
import { FastestShotLeaderboardItem } from '../../../Api/fastestShot/fastestShot.types'
import type { LeaderboardProps } from './Leaderboard.types'
import { LeaderboardHeader } from './LeaderboardHeader'
import {
  LeaderboardWrapper,
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  NameInfo,
  MPHText,
  TeamIconPlaceholder,
  TeamIcon,
  FanInfoCon,
} from './Leaderboard.styles'
import { Img } from '../../../Components/Image/Img'
import { capitalize, getTeamIc } from '../../../Utils'

export const Leaderboard: React.FC<LeaderboardProps> = ({
  title,
  boardType,
  leaderboard,
  handleLocationChange,
  availableMarkets,
  selectedMarketName,
}) => {
  const createSubLine = (location: string, fanScore: number) => {
    if (!location) return `LVL ${fanScore}`
    const shortLocation = location.split(',')[0]
    const locationLine = shortLocation ? `${capitalize(shortLocation)} •` : ''
    return `${locationLine} LVL ${fanScore}`
  }

  return (
    <LeaderboardWrapper>
      <LeaderboardHeader
        title={title}
        boardType={boardType}
        handleLocationChange={handleLocationChange}
        availableMarkets={availableMarkets}
        selectedMarketName={selectedMarketName}
      />
      <Table>
        <TableHeader>
          <tr>
            <TableHeaderCell width="10%" align="center">
              RANK
            </TableHeaderCell>
            <TableHeaderCell width="60%" align="left">
              Name
            </TableHeaderCell>
            <TableHeaderCell width="15%" align="right">
              MPH
            </TableHeaderCell>
          </tr>
        </TableHeader>
        <tbody>
          {leaderboard.length > 0 &&
            leaderboard.map((item: FastestShotLeaderboardItem, index: number) => (
              <TableRow key={`${item.name}-${item.rank}-${index}`}>
                <TableCell align="center">{item.rank}</TableCell>
                <TableCell align="left">
                  <FanInfoCon>
                    <NameInfo>
                      <p className="name">{item.name}</p>
                      <p className="location">
                        {createSubLine(item.location, item.fanScore)}
                      </p>
                    </NameInfo>
                    {!item.favTeam && <TeamIconPlaceholder />}
                    {item.favTeam && (
                      <TeamIcon>
                        <Img src={getTeamIc(item.favTeam)} alt={item.favTeam} />
                      </TeamIcon>
                    )}
                  </FanInfoCon>
                </TableCell>
                <TableCell align="right">
                  <MPHText>{item.shotSpeed}</MPHText>
                </TableCell>
              </TableRow>
            ))}
        </tbody>
      </Table>
    </LeaderboardWrapper>
  )
}
